// extracted by mini-css-extract-plugin
export default {"paymentForm":"PaymentForm_paymentForm__duGrG","cardElement":"PaymentForm_cardElement__4wjqy","donateButtonContainer":"PaymentForm_donateButtonContainer__DlH4J"};